// Déplace les tâches sélectionnées, dans leur ordre actuel, pour que la première arrive à `position` dans la file finale.
export const moveSelectionToPosition = (waitingIds, selectedIds, position) => {
    const selected = waitingIds.filter(id => selectedIds.includes(id))
    const rest = waitingIds.filter(id => !selectedIds.includes(id))
    const index = Math.min(Math.max(position - 1, 0), rest.length)

    return [...rest.slice(0, index), ...selected, ...rest.slice(index)]
}

export const toPriorityOrders = (ids) => ids.map((taskId, index) => ({taskId, priority: index + 1}))
